
import {
  viewDocument,
} from "../utiles/DocumentService";


const base64ToBlobUrl = (base64, fileName) => {
  const mimeType = fileName.toLowerCase().endsWith(".pdf")
    ? "application/pdf"
    : "image/jpeg";

  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], { type: mimeType });

  return URL.createObjectURL(blob);
};

export const fetchEmployeeImage = async (logoName, code) => {
    const orgcode = localStorage.getItem("custCode") || "ptw";
const envCode = localStorage.getItem("envcode") || "Prod";
  const folderPath = `${orgcode}/anexture_${code}`;
  try {
    const response = await viewDocument({
      projectCode: "Ptw",
      envCode: envCode,
      folderPath: folderPath,
      fileName: logoName,
    });

   if (response?.cd === 1) {
      return "";
    }

    if (response) {
      return base64ToBlobUrl(response, logoName);
    }

    return "";
  } catch (err) {
    console.error("Error in fetchEmployeeImage:", err);
    return "";
  }
};

export const fetchOrgImage = async (logoName, code) => {
    const orgcode = localStorage.getItem("custCode") || "ptw";
const envCode = localStorage.getItem("envcode") || "Prod";
  const folderPath = `${orgcode}/org_${code}`;
  try {
    const response = await viewDocument({
      projectCode: "Ptw",
      envCode: envCode,
      folderPath: folderPath,
      fileName: logoName,
    });

   if (response?.cd === 1) {
      return "";
    }
    if (response) {
      return base64ToBlobUrl(response, logoName);
    }

    return "";
  } catch (err) {
    console.error("Error in fetch Organization Image:", err);
    return "";
  }
};

export const fetchImagesAsBase64FromServer = async (
  fileNamesCSV,
  selectedDatacode,
) => {
  if (!fileNamesCSV) return [];

  const fileNames = fileNamesCSV.split(",");
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const envCode = localStorage.getItem("envcode") || "Prod";
  const folderPath = `${orgcode}/sc_${selectedDatacode}`;

  const previews = [];

  for (const name of fileNames) {
    try {
      const response = await viewDocument({
        projectCode: "Ptw",
        envCode,
        folderPath,
        fileName: name.trim(),
      });

      if (response?.cd === 1) {
        continue;
      }

      if (response) {
        previews.push(base64ToBlobUrl(response, name));
      }
    } catch (err) {
      console.warn(`❌ Failed to fetch image from server: ${name}`, err);
    }
  }

  return previews;
};

export const fetchRespImagesAsBase64FromServer = async (
  fileNamesCSV,
  selectedDatacode,
  dep,
) => {
  if (!fileNamesCSV) return [];

  const fileNames = fileNamesCSV.split(",");
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const envCode = localStorage.getItem("envcode") || "Prod";
  const folderPath = `${orgcode}/sc_${selectedDatacode}/dep_${dep}`;

  const previews = [];

  for (let name of fileNames) {
    try {
      const response = await viewDocument({
        projectCode: "Ptw",
        envCode: envCode,
        folderPath: folderPath,
        filenames: name.trim(),
      });

      if (response?.cd === 1) {
        continue;
      }

      if (response) {
        previews.push(base64ToBlobUrl(response, name));
      }
    } catch (err) {
      console.warn(`Failed to fetch image from server: ${name}`, err);
    }
  }

  return previews;
};
